export const BlankSheetsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="42" viewBox="0 0 56 42" fill="none">
    <path
      opacity="0.6"
      d="M3.13186 27.689L1.25808 30.7842C0.661243 31.7835 1.07764 33.0744 2.14639 33.5324L20.4261 41.2357C21.6059 41.7354 22.9523 41.5133 23.91 40.6805L27.033 37.9601L30.5723 39.1954C31.9742 39.6673 33.5148 39.3758 34.653 38.432C37.8315 35.8087 44.3411 30.0624 48.519 23.8998C52.3359 18.2646 54.0431 14.628 54.7926 12.6987C55.5422 10.7694 54.6538 10.8388 53.7378 10.5751L38.5393 6.05029L3.13186 27.689Z"
      fill="url(#paint0_linear_12972_199514)"
    />
    <path
      d="M11.7088 28.2024C10.4735 27.7305 10.1959 26.1066 11.2092 25.2599C13.8741 23.0253 18.385 18.9029 22.3408 13.6564C26.366 8.31262 29.1003 4.07927 30.4883 1.81686C31.1406 0.761988 32.4176 0.262314 33.5974 0.60931L51.6967 5.80037C53.0291 6.18901 53.7231 7.66027 53.1541 8.92334C51.7383 12.0879 48.8791 17.9036 44.7845 23.7748C41.0508 29.1324 37.1228 32.533 34.6661 34.3512C32.2094 36.1695 31.3349 35.6837 29.6555 35.0452L11.7088 28.2024Z"
      fill="white"
      stroke="#00217B"
      stroke-miterlimit="10"
      stroke-dasharray="2 2"
    />
    <path
      d="M44.0751 12.3793C42.5483 15.4884 39.4948 21.2208 35.2059 26.9393C32.7769 30.1733 30.3202 32.6578 28.1827 34.4899C26.8641 35.6142 25.6843 36.5025 24.7266 37.1687C23.2553 38.182 21.3538 38.3902 19.7021 37.6823L1.99141 30.2288C1.88038 30.1872 1.78322 30.1317 1.68606 30.0623C0.742228 29.4238 0.64507 28.008 1.5889 27.2724C4.33711 25.121 8.97298 21.1653 13.1092 16.0436C13.1231 16.0159 13.1508 15.9881 13.1647 15.9742C13.3451 15.766 13.5117 15.5439 13.6782 15.3357C17.5646 10.4639 20.2573 6.60532 21.6592 4.49558C22.3393 3.46847 23.6301 3.01044 24.8099 3.39907L28.6824 4.64826L36.6216 7.22991L42.7149 9.20085C44.0335 9.63112 44.6719 11.1301 44.0612 12.3793H44.0751Z"
      fill="white"
      stroke="#00217B"
      stroke-miterlimit="10"
      stroke-dasharray="2 2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12972_199514"
        x1="0.980479"
        y1="23.7887"
        x2="54.8898"
        y2="23.7887"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#258AE9" />
        <stop offset="0.2" stop-color="#228FE6" />
        <stop offset="0.5" stop-color="#1AA0E0" />
        <stop offset="0.7" stop-color="#0DBBD6" />
        <stop offset="1" stop-color="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
